import { render, staticRenderFns } from "./comment.vue?vue&type=template&id=0b1cdadd&scoped=true&"
import script from "./comment.vue?vue&type=script&lang=js&"
export * from "./comment.vue?vue&type=script&lang=js&"
import style0 from "./comment.vue?vue&type=style&index=0&id=0b1cdadd&scoped=true&lang=scss&"
import style1 from "./comment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1cdadd",
  null
  
)

export default component.exports